module.exports = __webpack_public_path__ + "static/media/illustration-element-09.714654f2.svg";